import React, { useEffect, useRef, useState } from "react";

const defaultRemainingTime = {
  days: "00",
  hours: "00",
  minutes: "00",
  seconds: "00",
};

export const ShowTime = React.forwardRef(
  ({ message, comparisionDate, props }, ref) => {
    const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);
    let interval = useRef();
    useEffect(() => {
      updateRemainingTime();
      return () => {};
    }, []);

    const updateRemainingTime = () => {
      let countDownTime = new Date(comparisionDate).getTime();

      let now = new Date().getTime();
      let remainingTime = parseInt(countDownTime) - parseInt(now);
      let oneMinute = parseInt(1000 * 60);
      let oneHour = oneMinute * parseInt(60);
      let oneDay = oneHour * parseInt(24);

      let days = Math.floor(remainingTime / oneDay);
      let hours = Math.floor((remainingTime % oneDay) / oneHour);
      let minutes = Math.floor((remainingTime % oneHour) / oneMinute);
      let seconds = Math.floor((remainingTime % oneMinute) / parseInt(1000));

      if (remainingTime <= 0) {
        clearInterval(interval.current);
      } else {
        setRemainingTime({
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds,
        });
      }
    };

    return (
      <>
        {message}
        {parseInt(remainingTime.days) > 0 && (
          <>
            <span>{remainingTime.days}</span>
            <span className={"me-1"}>D</span>
          </>
        )}
        {parseInt(remainingTime.hours) > 0 && (
          <>
            <span>{remainingTime.hours}</span>
            <span className={"me-1"}>H</span>
          </>
        )}
        {parseInt(remainingTime.minutes) > 0 && (
          <>
            {" "}
            <span>{remainingTime.minutes}</span>
            <span className={"me-1"}>M</span>
          </>
        )}
        {parseInt(remainingTime.seconds) > 0 && (
          <>
            <span>{remainingTime.seconds}</span>
            <span className={"me-1"}>S</span>
          </>
        )}
      </>
    );
  }
);
